import { useAddDepositSlice } from 'src/slices';
import { AssetContentTypeEnum, type Maybe } from 'src/graphql/schema';

import { createRequiredContext } from '../createRequiredContext';

type Props = {
  children: React.ReactNode;
  refetch?: () => void;
  storageRegion: Maybe<string> | undefined;
  contentType: AssetContentTypeEnum;
};

const [useAddDeposit, AddDepositProvider] = createRequiredContext<{
  ui: ReturnType<typeof useAddDepositSlice>;
  refetch?: () => void;
  contentType: AssetContentTypeEnum;
  storageRegion: Maybe<string> | undefined;
}>();

const AddDepositContextProvider = ({ refetch, children, contentType, storageRegion }: Props) => {
  const ui = useAddDepositSlice();
  const providerValue = {
    ui,
    refetch,
    contentType,
    storageRegion,
  };

  return <AddDepositProvider value={providerValue}>{children}</AddDepositProvider>;
};

export { useAddDeposit, AddDepositContextProvider };
